<template>
    <div class="p-md-4 p-3">
      <PaymentTransactionDetailModal :show="showTransactionModal" :toggle="toggleTransactionModal"
        :singleTransactionObj="singleTransactionObj" :refetch="refetch" />
      <div class="SectionItem no-b-b mb-3">
        <div>
          <p class="title m-0">Payment Transactions</p>
          <p class="text-left description">
            All transactions by Customers
          </p>
        </div>
        <div>
          <button class="btn btn-lg btn-secondary-inverted" @click="downloadLinks()">
            <span><img src="/assets/img/icons/document-download.svg" alt="" /></span>
            Export CSV
          </button>
        </div>
      </div>
      <div class="px-3">
        <FilterWrapper>
          <template slot="filterForm">
            <PaymentTransactionFilter :loading="loading" :rLoading="rLoading" :submitFilter="refetch"
              :clearFilter="() => clearFilter('providersRef')" />
          </template>
        </FilterWrapper>
      </div>
      <TableWrapper :loading="loading" :errorMsg="errorMsg" :refetch="fetchPaymentTransaction" :isEmpty="isEmpty"
        :emptyTitle="emptyTitle">
        <div class="w-100 py-3" slot="content">
          <v-server-table ref="providersRef" class="v-table row-pointer" :data="customers" :columns="columns"
            :options="options" @loaded="onLoaded" @loading="setLoading(true)" @row-click="handleClick">
            <template slot="source" slot-scope="{ row }">
              <p class="mb-0 ">
                {{ titleCase(row.source) || "Null" }}
              </p>
            </template>
            <template slot="type" slot-scope="{ row }">
              <p class="mb-0 ">
                {{ titleCase(row.type) || "Null" }}
              </p>
            </template>
            <template slot="amount" slot-scope="{ row }">
              &#8358;{{ formatNumber(row.amount) || "0" }}
            </template>
            <template slot="charges" slot-scope="{ row }">
              &#8358;{{ formatNumber(row.charges) || "0" }}
            </template>
            <div slot="status" slot-scope="{ row }">
              <span class="badge badge-app" :class="
                  row.status == 'successful' ? 'badge-success' : 'badge-danger'
                ">
                {{ titleCase(row.status) }}
              </span>
            </div>
            <div slot="accountName" slot-scope="{ row }">
              <span v-if="row.metadata.merchantName">
                {{ row.metadata.merchantName }}
              </span>
            </div>

            <template slot="updatedAt" slot-scope="{ row }">
              {{ row.updatedAt | moment(" MM-DD-YYYY h:mm a") }}
            </template>
          </v-server-table>
        </div>
      </TableWrapper>
    </div>
</template>

<script>

import { componentData } from "../../../public/assets/mixins/componentData";
import TableWrapper from "../../components/utils/TableWrapper/TableWrapper.vue";
import PaymentTransactionFilter from "../../components/filters/PaymentTransactionFilter.vue";
import { formatNumber, titleCase } from "../../components/utils/helpers";
import PaymentTransactionDetailModal from "./modals/PaymentTransactionDetailModal.vue";

const tableHeadings = {
  reference: "Transaction ID",
  amount: "Amount",
  charges: "Charges",
  source: "Payment Method",
  type: "Source",
  status: "Status",
  updatedAt: "Date Created",
};

export default {
  name: "PaymentTransactions",
  mixins: [componentData],
  data() {
    return {
      singleTransactionObj: null,
      showTransactionModal: false,
      emptyTitle: "No Data",
      loading: false,
      errorMsg: "",
      customers: [],
      ...this.tableOptions(tableHeadings, 25),
    };
  },
  components: {
    TableWrapper,
    PaymentTransactionFilter,
    PaymentTransactionDetailModal,
  },
  methods: {
    toggleTransactionModal() {
      this.showTransactionModal = !this.showTransactionModal;
    },
    handleClick({ row }) {
      this.singleTransactionObj = row;
      this.showTransactionModal = true;
    },
    formatNumber,
    titleCase,
    refetch(filters) {
      this.handleRefetch(filters, this.fetchPaymentTransaction, "providersRef");
    },
    async fetchPaymentTransaction() {
      this.options.requestFunction = async (data) => {
        const params = { ...data, ...this.filters, size: data.limit };
        const response = await this.$store.dispatch(
          "payment/getPaymentTransactions",
          {
            params,
          }
        );
        const newData = response.data.data;
        const count = response.data.total;
        return { ...response, count, total: count, data: newData };
      };
    },
    async downloadLinks() {
      const download = (filterData) =>
        this.downloadReport(tableHeadings, filterData.data);
      this.downloadTableReport("payment/getPaymentTransactions", download);
    },
  },
  created() {
    this.fetchPaymentTransaction();
  },
  mounted() {
    this.columns = Object.keys(tableHeadings).map((keyVal) => keyVal);
  },
};
</script>
